<template>
  <div>

    <v-dialog v-model="toggleDialog" min-width="700" width="700" persistent>
      <v-card  class="dialog_ricariche">
        <v-card-title class="headline ml-1">
          Acquista simulazioni
          <v-spacer></v-spacer>
          <v-btn color="black--text" icon @click="chiudiDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>

          <div class="_semi_bold ml-1" :style="`color:${scdOrange}`">{{ computedDescrizioneSconto }}</div>

          <v-item-group 
            v-model="idPrezzoStripeSelezionato"
            mandatory
          >
            <v-container>
              <v-row class="dialog_ricariche">
                <v-col
                  v-for="ricarica in ricariche"
                  :key="ricarica.id_prezzo_stripe"
                  cols="12"
                  md="3"
                  class="pa-1"
                >
                  <v-item 
                    v-slot="{ active, toggle }"
                    :value="ricarica.id_prezzo_stripe"
                  >
                    <v-card
                      :color="active ? scdOrange : scdColor"
                      class="d-flex flex-column align-center pa-4"
                      dark
                      flat
                      @click="toggle"
                    >
                      <v-img :src="`/img/ricariche_simulazioni/${ricarica.numero_simulazioni}_simulazioni.png`" style="border-radius:50%; border:2px solid #eeeeee;" contain></v-img>
                      <div class="_semi_bold mt-3 d-flex flex-column text-center">
                        <div class=" mr-1">{{ ricarica.costo }} € <span style="font-size:10px;" v-if="vatNumberValidated == 'valid'">+ 0% iva</span></div>
                        <div style="font-size:10px;">{{ vatNumberValidated != 'valid' ? 'compresa iva 20%' : '(inversione contabile)' }}</div>
                      </div>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>

        </v-card-text>
          <div class="d-flex justify-space-between px-7">
            <v-btn :color="scdColor" style="text-transform:none; padding:0 20px; color:white; letter-spacing:normal;" depressed rounded class="mr-4 mb-3" @click="chiudiDialog()">Chiudi</v-btn>   
            <div class="d-flex">
              <v-btn v-if="tastoCartaVisibile" :disabled="provaGratuita" :color="scdOrange" style="text-transform:none; padding:0 20px; color:white; letter-spacing:normal; min-width:200px; font-weight:600;" depressed rounded class="mb-3 mr-2" @click="vaiAlCarrello()"><span style="font-weight:400; font-size:12px;">Paga con&nbsp;</span>Carta</v-btn>
              <v-btn v-if="tastoPaypalVisibile" :disabled="provaGratuita" color="#ffc439" style="text-transform:none; padding:0 20px; color:#003087; letter-spacing:normal; min-width:200px; font-weight:600;" depressed rounded class="mb-3 mr-2" @click="apriPaypalCouponDialog()"><span style="font-weight:400; font-size:12px;">Paga con&nbsp;</span>PayPal</v-btn>
              <!-- <div v-if="tastoPaypalVisibile" class="_paypal" ref="paypal"></div> -->
            </div>
          </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="togglePaypalCouponDialog" min-width="700" width="700" persistent>
      <v-card  class="dialog_ricariche">
        <v-card-title class="headline ml-1">
          <div>
            <div :style="`font-size:23px; font-weight:500; color:${scdColor}; margin-bottom:3px;`">Pacchetto selezionato: <span :style="`color:${scdOrange};`">{{ ricaricaSelezionata.numero_simulazioni }} simulazioni</span></div>
            <div :style="`font-size:23px; font-weight:500; color:${scdColor}; margin-bottom:20px;`">Costo: <span :style="`color:${scdOrange};`">{{ ricaricaSelezionata.costo }} € {{ vatNumberValidated != 'valid' ? 'compresa iva 20%' : '+ 0% iva (inversione contabile)' }} {{ paypalCoupon.sconto != 0 && couponApplicato ? '(-' + paypalCoupon.sconto + '%)' : null }}</span></div>
          </div>
          <v-spacer></v-spacer>
          <v-btn class="align-self-start" color="black--text" icon @click="apriDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>

          <!-- <div :style="`font-size:23px; font-weight:500; color:${scdColor}; margin-bottom:10px;`">Pacchetto selezionato: <span :style="`color:${scdOrange};`">{{ ricaricaSelezionata.numero_simulazioni }} simulazioni</span></div>
          <div :style="`font-size:23px; font-weight:500; color:${scdColor}; margin-bottom:20px;`">Costo: <span :style="`color:${scdOrange};`">{{ costoSenzaIva(ricaricaSelezionata.costo) }} € + IVA {{ paypalCoupon.sconto != 0 && couponApplicato ? '(-' + paypalCoupon.sconto + '%)' : null }}</span></div> -->

          <div class="_semi_bold ml-1 mb-1" :style="`color:${scdColor}`">Hai un codice promozionale? inseriscilo qui sotto e clicca su "Applica"</div>
          <v-text-field v-model="paypalCoupon.codice" hide-details outlined single-line dense :readonly="couponApplicato">
            <template v-slot:append>
                <div v-if="!caricamentoPaypalCoupon && !couponApplicato" :style="`font-size:15px; font-weight:500; color:${scdColor}; cursor:pointer; margin-top:3px;`" @click="applicaPaypalCoupon()">Applica</div>
                <div v-if="!caricamentoPaypalCoupon && couponApplicato" :style="`font-size:15px; font-weight:500; color:${scdColor}; cursor:pointer; margin-top:0px;`" @click="rimuoviPaypalCoupon('click_sulla_x')"><v-icon>mdi-close-circle</v-icon></div>
                <v-progress-circular v-if="caricamentoPaypalCoupon" style="margin-top:1px;" size="20" width="2" indeterminate :color="scdColor"></v-progress-circular>
            </template>
          </v-text-field>

          <v-alert style="font-size: 14px; padding: 5px 10px !important;" :color="alertColor" v-if="true" :type="alertType" :value="alertVisible" outlined class="mt-1 mb-0">
            {{ paypalCoupon.messaggio }}
          </v-alert> 

        </v-card-text>
          <div class="d-flex justify-space-between px-7">
            <v-btn :color="scdColor" style="text-transform:none; padding:0 20px; color:white; letter-spacing:normal;" depressed rounded class="mr-4 mb-3" @click="apriDialog()">Indietro</v-btn>   
            <div class="d-flex">
              <div v-if="tastoPaypalVisibile" class="_paypal" ref="paypal"></div>
            </div>
          </div>
      </v-card>
    </v-dialog>
	
	  <v-dialog v-model="dialogCartaDisabilitata" min-width="700" width="700" persistent>
		  <v-card >
			  <v-card-title class="secondary--text">
				  ATTENZIONE!
			  </v-card-title>
			  <v-card-text class="font-weight-medium" style="color:rgba(0,0,0,.87)">
				  Per motivi tecnici, al momento non è possibile procedere con il pagamento tramite carta.<br>
				  Tuttavia, è possibile pagare ugualmente con carta usando l'opzione "Paga con Paypal" (anche se non si possiede un account Paypal): cliccare su "Paga con carta" e poi "Continua come utente non registrato".
			  </v-card-text>
			  <v-card-actions>
				  <v-spacer></v-spacer>
				  <v-btn :color="scdColor" style="text-transform:none; padding:0 20px; color:white; letter-spacing:normal;" depressed rounded @click="dialogCartaDisabilitata = false">Ok</v-btn>
			  </v-card-actions>
		  </v-card>
	  </v-dialog>

  </div>
</template>

<script src="https://js.stripe.com/v3/"></script>

<script>
import mixin from '../mixins';
export default {
  props: ['toggleDialog'],
  data() {
    return {
      alertColor: null,
      alertType: null,
      alertVisible: false,

      ricariche: [],
      vatNumberValidated: null,
      provaGratuita: null,
      idPrezzoStripeSelezionato: null,
      nomePacchetto: null,

      tastoCartaVisibile: false,

      // Per PayPal
      tastoPaypalVisibile: false,
      ricaricaSelezionata: {
        numero_simulazioni: 0,
        costo: 0,
      },
      backupCostoOriginale: 0,
      paypalCoupon: {
        codice: '',
        sconto: 0,
        messaggio: ''
      },
      togglePaypalCouponDialog: false,
      caricamentoPaypalCoupon: false,
      couponApplicato: false,
	
	    dialogCartaDisabilitata: false,
    }
  },
  watch: {
    toggleDialog: async function(dialogAperta) {
      if (dialogAperta) {
        await this.getRicariche();
        // if (!this.provaGratuita) {
        //   this.inserisciScriptPaypal();
        // }
      }
    },
    idPrezzoStripeSelezionato: function(id) {
      this.ricaricaSelezionata = this.ricariche.find(ricarica => ricarica.id_prezzo_stripe == id);
      this.backupCostoOriginale = this.ricaricaSelezionata.costo;
    }
  },
  methods: {
    costoSenzaIva(costo) {
      return (costo/1.22).toFixed(2)
    },
    apriPaypalCouponDialog() {
      if (!this.provaGratuita) {
        this.inserisciScriptPaypal();
        this.chiudiDialog();
        this.togglePaypalCouponDialog = true;
      }
    },
    chiudiPaypalCouponDialog() {
      this.togglePaypalCouponDialog = false;
      this.rimuoviPaypalCoupon('indietro');
    },
    applicaPaypalCoupon() {
      this.caricamentoPaypalCoupon = true;
      axios.post('/applica_coupon', { coupon: this.paypalCoupon.codice })
        .then(response => {
          let coupon = response.data;
          if (coupon.valido) {
            this.paypalCoupon.messaggio = coupon.messaggio;
            this.alertColor = 'green';
            this.alertType = 'success'
            this.alertVisible = true;

            // this.paypalCoupon.sconto = coupon.sconto;
            this.paypalCoupon.sconto = coupon.sconto;
            let valoreScontato = (this.ricaricaSelezionata.costo / 100) * this.paypalCoupon.sconto;
            this.backupCostoOriginale = this.ricaricaSelezionata.costo;
            this.ricaricaSelezionata.costo -= valoreScontato;
            this.couponApplicato = true;

          } else {
            this.paypalCoupon.messaggio = coupon.messaggio;
            this.alertColor = 'red';
            this.alertType = 'error'
            this.alertVisible = true;
          }
        })
        .finally(() => {
          this.caricamentoPaypalCoupon = false;
        })
    },
    rimuoviPaypalCoupon(azione = null) {
      if (azione == 'click_sulla_x' || azione == 'indietro') {
        this.ricaricaSelezionata.costo = this.backupCostoOriginale;
      }
      this.couponApplicato = false;
      this.alertVisible = false;
      this.paypalCoupon.codice = '';
    },
    inserisciScriptPaypal() {
      // Sendbox (Società Empatik EU)
      // const clientID = 'ARN_mfbPhCf9j1tjI8XHu-ye2At0kgB2PDPiFT_URCKvoen4Vkj20nmPQ5mRVV-9IQDnn7Hdo3gpf6HS';
	    
      // Live (Società Empatik EU)
      // const clientID = 'AXZ__V987u8YVbco1rFYfRtUrJK-hy6OBG2VodmlDTcs99MsnVLZg5J5h6L1OrxGG9U88mzZXkxMGheu';
	    
	    // Sendbox (Società Empatik EU)
	    // const clientID = 'AVsQNKmGn8fWNOtoWL689R4WGTrVfnzwWAqkqTrPmPVcXTEeQDzxMTXCiJLcVofPcyMVFA8bXlxkXD7-';
	    
	    // Live (Società Empatik EU)
	    const clientID = 'AZI8L977WpJJaXUIgQmNrRjWVZkGdQ_kvfS3o4s8su3R1cW_ea5Fiy4FK3LCEvjQ_WTBdaUCNvSrgFab';
			
      const script = document.createElement('script');
      // script.src = `https://www.paypal.com/sdk/js?client-id=${clientID}`;
      script.src = `https://www.paypal.com/sdk/js?client-id=${clientID}&currency=EUR&disable-funding=card,sofort,mybank`;
      script.addEventListener('load', this.setLoaded);
      document.body.appendChild(script);
    },
    setLoaded() {
      paypal.Buttons({
        // Sets up the transaction when a payment button is clicked
        createOrder: async (data, actions) => {
          const idOrdine = await actions.order.create({
            purchase_units: [
              {
                description: `Ricarica ${this.ricaricaSelezionata.numero_simulazioni.toString()} Simulazioni`,
                amount: {
                  currency_code: 'EUR',
                  value: this.ricaricaSelezionata.costo,
                },
                // Descrizione sull'estratto conto
                soft_descriptor: `${this.ricaricaSelezionata.numero_simulazioni.toString()} Simulaz`,
                // NON HO CAPITO COME AGGIUNGERE UNO SCONTO
                // discount: {
                //   value: '10'
                // }
              }
            ],
            application_context: {
              shipping_preference: 'NO_SHIPPING',
              brand_name: 'Simulatore Click Day',
              locale: 'it-IT',
            },
            // redirect_urls: {
            //   return_url: '/home'
            // }
          });

          await this.creaOrdinePaypal(idOrdine);

          return idOrdine;
        },
        // Finalize the transaction after payer approval
        onApprove: async (data, actions) => {
          const orderData = await actions.order.capture()

          let ordine = {
            transazione: {},
            pagatore: {}
          };
          ordine.id = orderData.id;
          ordine.status = orderData.status;
          ordine.data_ora_creazione_ordine = orderData.create_time;
          ordine.data_ora_aggiornamento_ordine = orderData.update_time;

          let transaction = orderData.purchase_units[0].payments.captures[0];
          ordine.transazione.id = transaction.id;
          ordine.transazione.status = transaction.status;
          ordine.transazione.data_ora_creazione_transazione = transaction.create_time;
          ordine.transazione.data_ora_aggiornamento_transazione = transaction.update_time;

          let payer = orderData.payer;
          ordine.pagatore.id = payer.payer_id;
          ordine.pagatore.nome = payer.name.given_name;
          ordine.pagatore.cognome = payer.name.surname;
          ordine.pagatore.email = payer.email_address;

          await this.completaOrdinePaypal(ordine);

          window.location.href = '/home';

          // return orderData;
        },
        style: {
          // color : 'white',
          shape: 'pill',
          size: 'responsive',
          label: 'pay'
        }
      }).render(this.$refs.paypal);
    },
    creaOrdinePaypal(id) {
      return axios.post('/paypal/crea_ordine', {
        idOrdine: id,
        costo: this.ricaricaSelezionata.costo,
        numero_simulazioni: this.ricaricaSelezionata.numero_simulazioni.toString()
      });
    },
    completaOrdinePaypal(ordine) {
      return axios.post('/paypal/completa_ordine', ordine);
    },
    chiudiDialog() {
      this.rimuoviPaypalCoupon();
      this.$emit('toggle-dialog', false);
    },
    apriDialog() {
      this.chiudiPaypalCouponDialog();
      this.$emit('toggle-dialog', true);
    },
    getRicariche() {
      return axios
      .get('/getRicariche')
      .then(response => {
        this.ricariche = response.data.ricariche;
        // this.vatNumberValidated = response.data.vatNumberValidated;
        this.provaGratuita = response.data.provaGratuita;
        this.nomePacchetto = response.data.nomePacchetto;

        if (!this.provaGratuita) {
          this.tastoPaypalVisibile = true;
          this.tastoCartaVisibile = true;
        }
      })
    },
    vaiAlCarrello() {
			this.dialogCartaDisabilitata = true;
      // axios.get(`/stripeCheckoutRicariche?idPrezzoStripeSelezionato=${this.idPrezzoStripeSelezionato}`)
      // .then(response => {
	    //   console.log(response.data)
      //   let checkout = response.data;
      //   window.location.href = checkout.url;
      // })
    },
  },
  computed: {
    computedDescrizioneSconto() {
      if (this.nomePacchetto == 'SIMULATORE_AZIENDA') {
        return 'I prezzi indicati includono il 10% di sconto sul prezzo di listino';
      } else if(this.nomePacchetto == 'SIMULATORE_CONSULENTE') {
        return 'I prezzi indicati includono il 20% di sconto sul prezzo di listino';
      }
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .dialog_ricariche {
    font-family: 'Montserrat', sans-serif !important;
    font-size: 14px;
    color: #6D94CD;
    font-weight: 400;
    line-height:1.5;
    padding-top: 20px;
  }
  ._bold {
    font-weight: 700;
  }
  ._semi_bold {
    font-weight: 600;
  }
</style>